import api from "../config/api";

export const getEmployees = async (data) => {
  const res = await api.get("employees", data);
  return res.data;
};

export const getEmployeeByid = async (_id) => {
  const res = await api.get(`employees/${_id}`);
  return res.data;
};
